// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ec08973552cefe94","5593":"eeee05552613a6c5"}[chunkId] + ".css";
};